module.exports = __webpack_public_path__ + "img/okkuLogo.49a53dd9.png";